// extracted by mini-css-extract-plugin
export var bgImage = "mainLayout-module--bg-image--bf405";
export var cls_1 = "mainLayout-module--cls_1--e5541";
export var dark = "mainLayout-module--dark--a592a";
export var eci_counter = "mainLayout-module--eci_counter--93c02";
export var eci_overlay = "mainLayout-module--eci_overlay--93635";
export var eci_popup_agital = "mainLayout-module--eci_popup_agital--faa67";
export var eci_popup_content = "mainLayout-module--eci_popup_content--8b2b0";
export var light = "mainLayout-module--light--a3d2f";
export var main = "mainLayout-module--main--4f9cd";
export var modalVideo = "mainLayout-module--modal-video--5c7e5";
export var modalVideoBody = "mainLayout-module--modal-video-body--8bcf3";
export var modalVideoCloseBtn = "mainLayout-module--modal-video-close-btn--73637";
export var modalVideoEffectExit = "mainLayout-module--modal-video-effect-exit--b1b50";
export var modalVideoInner = "mainLayout-module--modal-video-inner--33a4f";
export var modalVideoMovieWrap = "mainLayout-module--modal-video-movie-wrap--1e0fe";
export var noBottomPadding = "mainLayout-module--no-bottom-padding--45f4a";
export var variantUrl = "mainLayout-module--variantUrl--42126";